module.exports = __webpack_public_path__ + "908e4d2e/img/pdf-icon.79f04a36.svg";